
import Polygon from "../../../assets/filled/Polygon.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function PolygonIcon({ className, dataTestid = "PolygonIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Polygon data-testid={dataTestid} className={classes} {...rest} />
  );
}
